import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Grid, Row, Col } from 'react-flexbox-grid';

import ActionButton from 'components/ActionButton';

import { wrapper, title } from './Title.less';

const Title = ({ action, isHidden, localeId = '' }) => (
  <div className={wrapper}>
    <Grid fluid>
      <Row>
        <Col xs={6}>
          <h4 className={title}>
            <FormattedMessage id={localeId} />
          </h4>
        </Col>
        <Col xs={6}>
          <ActionButton localeId={isHidden ? 'editlog.show' : 'editlog.hide'} align="right" accent onClick={action} />
        </Col>
      </Row>
    </Grid>
  </div>
);

Title.propTypes = {
  localeId: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  isHidden: PropTypes.bool.isRequired,
};

export default Title;
